export enum RoleNames {
  ADMIN = 'Admin',
  ENCARGADO = 'Encargado',
  OWNER = 'OWNER', // Pseudo-role for gym owners
}

export const ROLE_NAMES = RoleNames;

export type RoleName = RoleNames;

export function isAdminRole(roleName: string | null | undefined): boolean {
  return roleName === RoleNames.ADMIN;
}

export function isEncargadoRole(roleName: string | null | undefined): boolean {
  return roleName === RoleNames.ENCARGADO;
}

export function canAccessFeature(
  userRole: string | null | undefined,
  allowedRoles: string[] | RoleNames[]
): boolean {
  if (!userRole) return false;
  // OWNER pseudo-role has access to everything
  if (userRole === RoleNames.OWNER) return true;
  return allowedRoles.includes(userRole as any);
}

export function getRoleDisplayName(roleName: string | null | undefined): string {
  if (!roleName) return '';

  switch (roleName) {
    case RoleNames.ADMIN:
      return 'Administrador';
    case RoleNames.ENCARGADO:
      return 'Encargado';
    case RoleNames.OWNER:
      return 'Propietario';
    default:
      return roleName;
  }
}

export function getRoleDescription(roleName: string | null | undefined): string {
  if (!roleName) return '';

  switch (roleName) {
    case RoleNames.ADMIN:
      return 'Acceso completo a todas las funcionalidades del gimnasio, gestión de colaboradores y configuración';
    case RoleNames.ENCARGADO:
      return 'Gestión diaria del gimnasio: clientes, contratos, check-ins y reportes';
    case RoleNames.OWNER:
      return 'Acceso completo a todas las funcionalidades, organización y suscripción';
    default:
      return '';
  }
}

export function getRoleCapabilities(roleName: string | null | undefined): string[] {
  if (!roleName) return [];

  switch (roleName) {
    case RoleNames.OWNER:
      return [
        'Acceso completo a todas las funcionalidades',
        'Gestión de organización',
        'Gestión de suscripción y facturación',
        'Gestión completa de clientes',
        'Gestión completa de contratos',
        'Gestión de colaboradores',
        'Configuración del gimnasio',
        'Gestión de planes',
        'Gestión de proveedores',
        'Gestión de métodos de pago',
        'Reportes y estadísticas',
        'Gestión de inventario',
        'Check-ins',
      ];
    case RoleNames.ADMIN:
      return [
        'Gestión completa de clientes',
        'Gestión completa de contratos',
        'Gestión de colaboradores',
        'Configuración del gimnasio',
        'Gestión de planes',
        'Gestión de proveedores',
        'Gestión de métodos de pago',
        'Reportes y estadísticas',
        'Gestión de inventario',
        'Check-ins',
      ];
    case RoleNames.ENCARGADO:
      return [
        'Gestión de clientes (ver, crear, editar)',
        'Creación y renovación de contratos',
        'Check-ins',
        'Ver reportes',
        'Gestión de inventario',
        'Ventas',
      ];
    default:
      return [];
  }
}